const LocationActions = {
    UPDATE: 'UPDATE_LOCATIONS',
}

export default LocationActions;